import Flex from "app/components/UI/Flex";
import Icon from "app/components/UI/Icon";
import PropTypes from "prop-types";
import React from "react";
import classes from "./SelectableList.module.css";
import classnames from "classnames";

export const SelectableItem = ({ className, isSelected, title, subtitle, club, numCard, ...props }) => (
  <Flex
    direction="row"
    middle
    className={classnames(classes.selectableItem, className, {
      [classes.isSelected]: isSelected
    })}
    {...props}
  >
    {isSelected ? (
      <Icon className={classes.selectableItem__radio}>radio_button_checked</Icon>
    ) : (
      <Icon className={classes.selectableItem__radio}>radio_button_unchecked</Icon>
    )}
    <Flex direction="column" size={1}>
      <div className={classes.selectableItem__title}>{title}</div>
      <div className={classes.selectableItem__subtitle}>{subtitle}</div>
    </Flex>
  </Flex>
);

SelectableItem.propTypes = {
  isSelected: PropTypes.bool,
  className: PropTypes.string,
  title: PropTypes.string,
  subtitle: PropTypes.string,
  club: PropTypes.string,
  numCard: PropTypes.string
};

export default SelectableItem;



// WEBPACK FOOTER //
// ./src/app/components/UI/SelectableList/SelectableItem.js